import gql from 'graphql-tag';

const UPDATE_SEQUENCE_GENERATORS = gql`
  mutation($sequenceGeneratorInput: [UpdateSequenceGeneratorInput]) {
    updateSequenceGenerators(input: $sequenceGeneratorInput) {
      name
      value
    }
  }
`;

export { UPDATE_SEQUENCE_GENERATORS };
